// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
export function dispatchEchartResetPosition() {
    window.dispatchEvent(new CustomEvent("PM-Echarts-ResetPosition", {}));
}
